import {type FromSchema} from 'json-schema-to-ts'

export const shipmentTrackingMilestoneChangedNotification = {
  title: 'Shipment Tracking Milestone Change Notification Schema.',
  description: 'Notification sent when a shipment tracking milestone changes.',
  $ref: '#/definitions/Notification',
  examples: [
    {
      notificationVersion: '1.0',
      notificationType: 'SHIPMENT_TRACKING_MILESTONE_CHANGED',
      payloadVersion: '2026-01-30',
      eventTime: '2025-08-08T12:45:48.501Z',
      notificationMetadata: {
        applicationId: 'amzn1.sellerapps.app.g2134566-aaec-55a6-b123-bcb752069ba4',
        subscriptionId: '7b28cc50-95c8-4641-add7-10af4b1fecd8',
        publishTime: '2025-08-08T12:47:50.501Z',
        notificationId: '6712e8e5-b365-4cb1-9fd8-be9dfc6d5bda',
      },
      payload: {
        shipmentTrackingMilestoneChangedNotification: {
          trackingDetail: {
            identifier: {
              aftn: 'AFTN987654321',
            },
            latestMilestone: {
              status: {
                code: 'DELIVERED',
                subCode: 'PORCH',
                description: 'Shipment delivered to porch',
              },
              location: {
                address: {
                  city: 'Austin',
                  region: 'Texas',
                  countryCode: 'US',
                },
              },
              occurredAt: '2026-06-14T01:26:56Z',
            },
            milestoneHistory: [
              {
                status: {
                  code: 'DELIVERED',
                  subCode: 'PORCH',
                  description: 'Shipment delivered to porch',
                },
                location: {
                  address: {
                    city: 'Austin',
                    region: 'Texas',
                    countryCode: 'US',
                  },
                },
                occurredAt: '2026-06-14T01:26:56Z',
              },
              {
                status: {
                  code: 'OUT_FOR_DELIVERY',
                  description: 'Shipment is out for delivery',
                },
                location: {
                  address: {
                    city: 'Buda',
                    region: 'Texas',
                    countryCode: 'US',
                  },
                },
                occurredAt: '2026-06-13T16:20:51Z',
              },
              {
                status: {
                  code: 'SHIPPED',
                  description: 'Shipment has departed origin',
                },
                occurredAt: '2026-06-13T05:21:43Z',
              },
              {
                status: {
                  code: 'CARRIER_ASSIGNED',
                  description: 'Carrier was assigned',
                },
                occurredAt: '2026-06-13T04:41:37Z',
              },
              {
                status: {
                  code: 'ORDER_PREPARING',
                  description: 'Order is preparing to ship',
                },
                occurredAt: '2026-06-12T19:43:40Z',
              },
            ],
            trackingEstimates: [
              {
                type: 'ESTIMATED_DELIVERY_DATE',
                estimatedInterval: {
                  startTime: '2026-06-14T03:00:00Z',
                  endTime: '2026-06-14T03:00:00Z',
                },
                lastUpdatedTime: '2026-06-13T05:21:43Z',
              },
            ],
            trackingUrl: 'https://www.swiship.com/track?id=AFTN987654321',
          },
        },
      },
    },
  ],
  definitions: {},
} as const

export type ShipmentTrackingMilestoneChangedNotification = FromSchema<
  typeof shipmentTrackingMilestoneChangedNotification
>
